import StatusNotificationPrefix from './StatusNotificationPrefix';

export default StatusNotificationPrefix;
